import { Grid } from "@mui/material";
import React from "react";
import GMap from "./GMap/GMap";

function DashBoard() {
  return (
    <Grid
      sx={{
        width: "77%",
        height: "98vh",
        padding: "0px 25px",
      }}
    >
      <Grid
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: "15px",
        }}
      >
        <GMap/>
      </Grid>
    </Grid>
  );
}

export default DashBoard;
